import { Box, Grid } from "@mui/material";

import {
  RRDAddressArea,
  RRDCardFace,
  RRDCouponGrid,
  RRDExpirationText,
  RRDFixedImageSlot,
  RRDImageSlot,
  RRDPageLabel,
} from "./RRDTemplateSlots";
import { couponSlots, fixedSlot, slotsByType } from "./rrdLayoutSlotHelpers";
import type { RRDLayoutProps } from "./layoutTypes";

function BasicPostcard3CFixedLayout(props: RRDLayoutProps) {
  const {
    layoutSpec,
    heroImages,
    coupons,
    fixedImages,
    frontExpirationDate,
    mode,
  } = props;
  const heroSlot = slotsByType(layoutSpec, "hero_image")[0];
  const cardAspectRatio =
    layoutSpec?.faceAspectRatio || heroSlot?.aspectRatio || "14 / 9";

  return (
    <Grid
      container
      spacing={5}
      justifyContent="center"
      size={12}
      data-testid="rrd-layout-basic-postcard-1h-3c-fixed"
    >
      <Grid size={{ xs: 12, lg: 10 }}>
        <RRDPageLabel>Front</RRDPageLabel>
        <RRDCardFace
          data-testid="rrd-cicis-front-panel"
          aspectRatio={cardAspectRatio}
        >
          <RRDImageSlot
            {...props}
            slot={heroSlot}
            placeholder="Hero Image"
            imageSx={{ objectFit: "cover" }}
            sx={{
              aspectRatio: "auto",
              height: "100%",
            }}
          />
        </RRDCardFace>
      </Grid>
      <Grid size={{ xs: 12, lg: 10 }}>
        <RRDPageLabel>Back</RRDPageLabel>
        <RRDCardFace
          data-testid="rrd-cicis-back-panel"
          aspectRatio={cardAspectRatio}
          sx={{
            mt: 2,
          }}
        >
          <Box
            data-testid="rrd-cicis-back-content"
            sx={{
              display: "grid",
              gridTemplateColumns:
                layoutSpec?.backPanelColumns || "3.6fr 3.95fr",
              alignItems: "stretch",
              height: "100%",
            }}
          >
            <Box data-testid="rrd-cicis-coupon-column">
              <RRDCouponGrid
                slots={couponSlots(layoutSpec, "back")}
                layoutSpec={layoutSpec}
                heroImages={heroImages}
                coupons={coupons}
                mode={mode}
                onOpenMobileSlot={props.onOpenMobileSlot}
                onRemoveAsset={props.onRemoveAsset}
                readOnly={props.readOnly}
                fillHeight
              />
            </Box>
            <Box
              data-testid="rrd-cicis-mailing-column"
              sx={{
                display: "flex",
                flexDirection: "column",
                height: "100%",
                minHeight: 0,
              }}
            >
              <RRDFixedImageSlot
                data-testid="rrd-cicis-fixed-image"
                fixedImages={fixedImages}
                slot={fixedSlot(layoutSpec)}
                style={{
                  aspectRatio:
                    layoutSpec?.fixedImageAspectRatio || "3.95 / 2.5",
                }}
                sx={{
                  minHeight: 72,
                  border: "none",
                  background: "transparent",
                  "& img": {
                    objectPosition: "left center",
                  },
                  flexShrink: 0,
                }}
              />
              <RRDAddressArea
                data-testid="rrd-cicis-address-area"
                sx={{ flex: 1, height: "auto", minHeight: 0 }}
              />
            </Box>
          </Box>
        </RRDCardFace>
        <RRDExpirationText>{frontExpirationDate}</RRDExpirationText>
      </Grid>
    </Grid>
  );
}

export default BasicPostcard3CFixedLayout;
